import React from 'react';

const Toggle = ({
  checked,
  onChange,
  label,
  className = '',
  labelPosition = 'left' // 'left' ou 'right'
}) => {
  return (
    <label className={`flex items-center cursor-pointer ${className}`}>
      {labelPosition === 'left' && label && (
        <span className="mr-2 text-sm text-gray-700 dark:text-gray-300">{label}</span>
      )}

      <div className="relative">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={onChange}
        />
        <div className={`block w-10 h-6 rounded-full transition ${checked ? 'bg-blue-500' : 'bg-gray-400'}`}></div>
        <div className={`absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform ${checked ? 'transform translate-x-4' : ''}`}></div>
      </div>

      {labelPosition === 'right' && label && (
        <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">{label}</span>
      )}
    </label>
  );
};

export default Toggle;
